// BE trả lỗi dạng { message, errors: { field: [msg, ...] } } (422 Laravel).
export const getApiFieldErrors = (error: any): Record<string, string> => {
  const errors = error?.response?.data?.errors;
  if (!errors || typeof errors !== 'object') return {};

  return Object.fromEntries(
    Object.entries(errors)
      .map(([field, messages]) => [field, Array.isArray(messages) ? messages[0] : messages])
      .filter(([, message]) => typeof message === 'string' && message)
  ) as Record<string, string>;
};

// Lỗi của field không có ô trên form (classId, role...) được ghép vào message,
// nếu không người dùng chỉ thấy "Dữ liệu không hợp lệ" mà không biết vì sao.
export const getApiErrorMessage = (error: any, fallback: string, shownFields: string[] = []): string => {
  const message = error?.response?.data?.message || fallback;
  const hiddenMessages = Object.entries(getApiFieldErrors(error))
    .filter(([field]) => !shownFields.includes(field))
    .map(([, fieldMessage]) => fieldMessage);

  return hiddenMessages.length ? `${message}: ${hiddenMessages.join('; ')}` : message;
};
